/*
 * @Descripttion: 
 * @Date: 2021-07-02 15:25:06
 * @LastEditors: Lj07
 * @LastEditTime: 2021-08-25 11:16:18
 */
const pro = 'https://erpapi.hfbsoftware.com'
const dev = 'https://testerp.hfbsoftware.com'

const host = {}
host.host = process.env.NODE_ENV === 'production' ? pro : dev
host.mode = process.env.NODE_ENV === 'production' ? 'pro' : 'dev'


export default host


// WEBPACK FOOTER //
// ./src/Interface/host.js